export enum LeadAction {
  SCHEDULE_SHOWING = 'Schedule showing',
  SEND_APPLICATION = 'Send application',
}
